import React, { useEffect, useRef, useState } from 'react';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import WeeklyScheduleTimeData from './WeeklyScheduleTimeData';

/* 1セルの高さ定義 */
const itemHeight = 60;

type Props = {
  section: string;
  startTime: string;
  endTime: string;
  sectionData: any;
};

const timeTableWrap = {
  // 区画数で変更する
  width: 'calc(100% / 3.7)',
  margin: 0,
  padding: 0
};

const timeTableTitle: any = {
  height: '100px',
  borderLeft: 'solid 1px #ccc',
  borderBottom: 'solid 1px #ccc',
  margin: 0,
  marginLeft: '-1px',
  padding: 0,
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  alignContent: 'center'
};

const timeTableStage = {
  margin: 0,
  padding: 0
};

const timeTableItems = {
  // listStyleType: 'none',
  justifyContent: 'center',
  margin: 0,
  padding: 0
};
const timeTableItem: any = {
  height: `${itemHeight}px`,
  borderRight: 'solid 1px #ccc',
  borderBottom: 'solid 1px #ccc',
  margin: 0,
  padding: 0,
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

dayjs.extend(customParseFormat);
const ScheduleTimeTable = (props: Props) => {
  const { section, startTime, endTime, sectionData } = props;

  /* 表示領域の幅計算（幅調整ができないため、計算して設定する） */
  const targetRef = useRef<HTMLUListElement>(null);
  const [ulWidth, setUlWidth] = useState<number>(0);

  useEffect(() => {
    setUlWidth(targetRef.current ? targetRef.current.offsetWidth : 0);
  }, []);

  // 改行させるため別々で設定
  const days = dayjs(section).format('D');
  const dayObWeek = dayjs(section).format('dd');

  // 開始から終了時刻までを30分刻みで配列化する
  const initTimeLine = () => {
    const result: string[] = [];

    let currentTime = dayjs(startTime, 'HH:mm');
    const finishTime = dayjs(endTime, 'HH:mm');

    while (currentTime <= finishTime) {
      result.push(currentTime.format('HH:mm'));
      // TODO 施設ごとに可変対応
      // currentTime = currentTime.add(30, 'minute');
      currentTime = currentTime.add(60, 'minute');
    }

    return result;
  };
  const timeLines = initTimeLine();

  const dayColor = (day: string) => {
    let fontColor;
    switch (day) {
      case '土':
        fontColor = '#5DC1F2';
        break;
      case '日':
        fontColor = '#EF556D';
        break;
      default:
        break;
    }
    return {
      fontSize: '20px',
      color: fontColor
    };
  };

  return (
    <dl style={timeTableWrap}>
      <dd style={timeTableStage}>
        <ul style={timeTableItems} key={`title${section}`} ref={targetRef}>
          <li style={{ ...timeTableTitle, position: 'fixed', zIndex: 998, width: ulWidth }} key={section}>
            <span style={dayColor(dayObWeek)}>
              {days}
              <br />
              {dayObWeek}
            </span>
          </li>
          {/* 調整用 */}
          <div style={timeTableTitle} key="maintenance" />
        </ul>
      </dd>
      <dd style={timeTableStage}>
        <ul style={timeTableItems} key={`item${section}`}>
          {timeLines.map((v, index) => (
            <li style={timeTableItem} key={v}>
              {index === timeLines.length - 1 ? '-' : ' '}
            </li>
          ))}
          {sectionData && (
            <WeeklyScheduleTimeData availabilityList={sectionData.availabilityList} date={sectionData.date} />
          )}
        </ul>
      </dd>
    </dl>
  );
};
export default ScheduleTimeTable;
